import backIcon from '../../../assets/images/snack-shop/back.svg';
import snackIcon from '../../../assets/images/snack-shop/snack.png';

export default function SnackShopFrame({ title, snackCount, onBack, children }) {
  return (
    <section className="min-h-screen w-full bg-[linear-gradient(180deg,#F0ECFF_3.42%,#D0C9FF_100%)] pb-10 font-['Pretendard'] text-black">
      <header className="relative flex h-14 items-center justify-center px-[15px]">
        <button
          type="button"
          className="absolute left-[15px] flex h-9 w-9 items-center justify-start border-0 bg-transparent p-0"
          onClick={onBack}
          aria-label="뒤로 가기"
        >
          <img src={backIcon} alt="" width={37} height={16} />
        </button>
        <h1 className="text-[17px] font-bold leading-[1.3]">{title}</h1>
        <div className="absolute right-[15px] flex h-[27px] min-w-[67px] items-center justify-center gap-0.5 rounded-[20px] bg-white pl-1.5 pr-2">
          <img
            src={snackIcon}
            alt=""
            width={23}
            height={19}
            className="h-[19px] w-[23px] object-cover shadow-[1px_1px_5px_0px_#ffd362]"
          />
          <span className="text-[16px] font-medium leading-[1.3]">{Number(snackCount || 0).toLocaleString()}</span>
        </div>
      </header>
      {children}
    </section>
  );
}
